module.exports = __webpack_public_path__ + "static/media/radio_background_circle.9636c386.webm";